import { render, staticRenderFns } from "./ChatReportPlacesList.vue?vue&type=template&id=a3c8d082"
import script from "./ChatReportPlacesList.vue?vue&type=script&lang=ts"
export * from "./ChatReportPlacesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports